import React from "react";
// Rendering individual images
const Image = ({ image }) => {
    return (
        <div className="file-item">
            <img
                alt={`img - ${image.id}`}
                src={image.src}
                className="file-img"
            />
        </div>
    );
};


export default function ImageGride(props) {
    // render each image by calling Image component
    function renderImage(image, index) {
        return (
            <div className="w-full flex flex-wrap tr" key={`${image.id}-image`} >
                <div className="relative basis-6/12 td">
                    <div className="image-layout">
                        <button
                            className="btn btn-transparent mr-0"
                            onClick={props.deleteImage.bind(this, index)}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z" fill="#242424" />
                            </svg>
                        </button>
                        <Image image={image} />
                    </div>
                </div>
                <div className="basis-6/12 td flex items-center justify-center">
                    {image.name}
                </div>
            </div>
        );
    };

    // Return the list of files//
    return (
        <section className="file-list table w-8/12">
            <div className="thead">
                <div className="flex tr">
                    <div className="th basis-6/12">File</div>
                    <div className="th basis-6/12">Nama File</div>
                </div>
            </div>
            <div className="tbody">
                {props.images.map(renderImage)}
            </div>
        </section>
    );
};
